import { useAnalytics } from 'context/AnalyticsContext';

const useTrackerWrapper = () => {
  const { analytics } = useAnalytics();

  const onClickWrapper: (label: string, onClick: () => void) => void = (
    label,
    onClick,
  ) => {
    if (label) analytics?.track(`${label} Clicked`);
    onClick?.();
  };

  return { onClickWrapper };
};

export default useTrackerWrapper;
